import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvailableBranchPipe } from './available-branch.pipe';
import { ChangeBranchComponent } from '../change-branch.component';
import { IonicModule } from '@ionic/angular';
import { BranchComponent } from 'src/app/components/branch/branch.component';
import { MapsComponentsModule } from 'src/app/maps-components/maps-components.module';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { PipeModule } from '../../../pipes/pipe-module.module';

const declarations = [
  AvailableBranchPipe,
  ChangeBranchComponent,
  BranchComponent,
];

@NgModule({
  declarations,
  exports: declarations,
  imports: [
    CommonModule,
    IonicModule,
    MapsComponentsModule,
    GeneralesComponentsModule,
    PipeModule,
  ],
})
export class BranchComponentsModule {}
